import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { formatCountdownDisplay } from "@/lib/utils";

const ResetPinModal = ({
  open,
  onOpenChange,
  forgotPinEmail,
  otp,
  setOtp,
  newPin,
  setNewPin,
  confirmPin,
  setConfirmPin,
  errors,
  isOtpLoading,
  isResetLoading,
  resendCountdown,
  onSendOtp,
  onHandleResetPin,
}) => {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent className="sm:max-w-[440px] bg-color2 border border-color3 p-5">
        <DialogTitle className="text-color5">Reset PIN</DialogTitle>

        <p className="text-sm text-color4 mt-1">
          OTP will be sent to:
          <span className="ml-1 text-color6 font-medium">{forgotPinEmail}</span>
        </p>

        <form className="mt-3 space-y-3" onSubmit={onHandleResetPin}>
          <div>
            <input
              type="text"
              value={otp}
              onChange={(event) => setOtp(event.target.value)}
              placeholder="Enter OTP"
              className="w-full h-10 text-sm rounded-md border border-color3 bg-cblack5 px-3 text-color5 outline-none focus:border-color6"
            />
          </div>

          <div>
            <input
              type="text"
              inputMode="numeric"
              value={newPin}
              onChange={(event) => {
                const value = event.target.value.replace(/\D/g, "").slice(0, 5);
                setNewPin(value);
              }}
              placeholder="Enter new PIN (5 digits)"
              maxLength="5"
              className="w-full h-10 text-sm rounded-md border border-color3 bg-cblack5 px-3 text-color5 outline-none focus:border-color6"
            />
            {errors.newPin && (
              <p className="text-xs text-red-500 mt-1">{errors.newPin}</p>
            )}
          </div>

          <div>
            <input
              type="text"
              inputMode="numeric"
              value={confirmPin}
              onChange={(event) => {
                const value = event.target.value.replace(/\D/g, "").slice(0, 5);
                setConfirmPin(value);
              }}
              placeholder="Confirm PIN (5 digits)"
              maxLength="5"
              className="w-full h-10 text-sm rounded-md border border-color3 bg-cblack5 px-3 text-color5 outline-none focus:border-color6"
            />
            {errors.confirmPin && (
              <p className="text-xs text-red-500 mt-1">{errors.confirmPin}</p>
            )}
          </div>

          <div className="flex items-center justify-between gap-3 pt-1">
            <button
              type="button"
              onClick={() => onSendOtp(forgotPinEmail)}
              disabled={isOtpLoading || resendCountdown > 0}
              className="px-3 h-9 text-sm rounded-md bg-color3 text-color5 disabled:opacity-60"
            >
              {isOtpLoading
                ? "Sending..."
                : resendCountdown > 0
                  ? `Resend OTP (${formatCountdownDisplay(resendCountdown)})`
                  : "Resend OTP"}
            </button>

            <button
              type="submit"
              disabled={isResetLoading}
              className="px-4 h-9 text-sm rounded-md bg-color6 text-color1 font-medium disabled:opacity-60"
            >
              {isResetLoading ? "Resetting..." : "Reset PIN"}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ResetPinModal;
